import React from "react";
import Helmet from "react-helmet";
import { REACT_APP_COLBI_THEME } from "../environmentVariables";

function HeadChange() {
    return (
        <>
            <Helmet>
                <title>{`${REACT_APP_COLBI_THEME}`}</title>
                <link rel="icon" type="image/png" href={`/${REACT_APP_COLBI_THEME}.png`} />
            </Helmet>
        </>
    );
}
export default HeadChange;
